// AssetTable.tsx
import React, { useMemo, useState,useRef,useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-grid.css";
import SearchBar from "../../SearchBarTable/SearchBarTable"; 
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-theme-alpine.css";
// @ts-ignore CSS is loaded by the application bundler.
import "../AgGridTheme.css";
import SortHeader from "../SortingHeader";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule
} from "ag-grid-community";
import { FaSearch, FaArrowUp ,FaCubes,FaGlobe} from "react-icons/fa";
import { FiPackage } from "react-icons/fi";
import { ImPower } from "react-icons/im";

// Register AG Grid modules
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);

interface AssetTableProps {
  assets: any[];
  selectedAsset: any | null;
  setSelectedAsset: (asset: any) => void;
  onDeleteSelected: () => void;
  onRowSelect: (asset: any) => void;
  onClearSelection: () => void;
  // fetchAssets: (searchQuery: string) => void;
  selectedRow: string | null;
}

const AssetTable: React.FC<AssetTableProps> = ({
  assets,
  selectedAsset,
  setSelectedAsset,
  onRowSelect,
  onClearSelection,
  onDeleteSelected,
  // fetchAssets,
  selectedRow,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [gridApi, setGridApi] = useState<any>(null);
  const gridRef = useRef<AgGridReact>(null);

  // const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value;
  //   setSearchQuery(value);
  //   fetchAssets(value);
  //   if (gridApi) {
  //     gridApi.setQuickFilter(value);
  //   }
  // };
  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };
  const filteredAssets = useMemo(() => {
    const lowerSearchQuery = searchQuery.toLowerCase();
    return assets.filter(group =>
      group.asset_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.generation_subtype_code?.toLowerCase().includes(lowerSearchQuery) ||
      group.iso_code?.toLowerCase().includes(lowerSearchQuery) ||
      group.nameplate_rating_mw?.toString().toLowerCase().includes(lowerSearchQuery) 
      // group.iso_resource_name?.toLowerCase().includes(lowerSearchQuery) 
    );
  }, [assets, searchQuery]);
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Asset",
        field: "asset_name",
        sortable: true,
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Asset',
          enableSorting: true,
          icon: <FaCubes className="text-gray-600" /> 
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer rounded-tl-xl"
      },      
      {
        headerName: "Asset Type",
        field: "generation_subtype_code",
        sortable: true,
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader,
        headerComponentParams: {
          displayName: 'Asset Type',
          enableSorting: true,
          icon: <FiPackage className="text-gray-600" />
        }
      },      
      {
        headerName: "ISO",
        field: "iso_code",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO',
          enableSorting: true,
          icon: <FaGlobe className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Name Plate Rating",
        field: "nameplate_rating_mw",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Name Plate Rating',
          enableSorting: true,
          icon: <ImPower className="text-gray-600" /> 
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      }
      
    ],
    []
  );

  const defaultColDef = useMemo(() => ({
    sortable: false,
    // filter: true,
    // floatingFilter: true,
    resizable: true,
    cellStyle: {
      padding: "8px 12px",
      fontSize: "16px",
      fontFamily: "'Poppins', sans-serif",
      color: "#374151",
    },
  }), []);

  return (
    <div className="p-4 bg-white shadow-md rounded-xl font-poppins">
      {/* <div className="flex justify-between items-center mb-4">
        <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full w-full max-w-md">
          <FaSearch className="mr-2 text-gray-600" />
          <input
            type="text"
            placeholder="Search assets..."
            className="bg-transparent outline-none w-full"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      </div> */} 
       {/* <div className="flex justify-between items-center space-x-4 mb-7"> */}
        <div className="flex justify-between items-center mb-4">
           <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search assets..."
        />
      </div>
      </div>
      <div
        className="ag-theme-alpine  font-poppins text-base text-gray-700"
        style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", width: "100%",overflow:'auto', border: '1px solid #E7E4FF', borderRadius: '8px' }}
      >
        <AgGridReact
        theme="legacy"
          rowData={filteredAssets}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          domLayout="normal"
          rowHeight={60}
          headerHeight={55}
          
          // floatingFiltersHeight={55}
          pagination={true}
          paginationPageSize={50}
          // rowGroupPanelShow="always"
          // groupDisplayType="multipleColumns"
          className="ag-theme-alpine"
          suppressRowHoverHighlight={false}
          // columnHoverHighlight={true}
          onGridReady={(params) => setGridApi(params.api)}
          onRowClicked={(event) => onRowSelect(event.data)}
          getRowClass={(params) =>
            params.data.asset_name === selectedRow ? "ag-row-selected-custom" : ""
          }
        />
      </div>

 
    </div>
  );
};

export default AssetTable;
